import React, { FormEvent, useState } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin } from "react-icons/fa";

import Section from '../../../components/Section';
import theme from '../../../styles/theme';
import { fadeInUp } from '../../../variants';
import { ContactIntroduction, DivStyleWidth, FlexContainerGrid, Form } from '../../../styles/pages/Home';
import Input from '../../../components/Input';
import TextArea from '../../../components/TextArea';
import Button from '../../../components/Button';
import { Api } from '../../../services/api';
import Alert, { AlertBType } from '../../../components/Alert';
import Loading from '../../../components/Loading';
import RenderIf from '../../../components/RenderIf';

// import { Container } from './styles';

const Contact: React.FC = () => {

    const [inputs, setInputs] = useState(
        {
            name: '',
            email: '',
            description: ''
        }
    )

    const [loading, setLoading] = useState(false);

    const [alert, setAlert] = useState<AlertBType>({
        iconCheck: false,
        message: '',
        opacity: 0,
        visibility: 'hidden'
    })

    const handleOnSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await Api.post("/send-email", inputs);
            const data = response.data;
            setAlert({ iconCheck: true, message: data.message, opacity: 1, visibility: 'visible' });
            setInputs({ name: '', email: '', description: '' });
        } catch (error: any) {
            setAlert({
                iconCheck: false,
                message: error.response.data.message,
                opacity: 1, visibility: 'visible'
            })
        } finally {
            setLoading(false);
        }
    }

    return (
        <Section backgroundColor={theme.colors.primary} id='contact'>
            <div className='container'>
                <motion.h1 variants={fadeInUp}>Contato</motion.h1>
                <motion.span className="sub-title" variants={fadeInUp}>Entre em Contato</motion.span>
                <DivStyleWidth>
                    <FlexContainerGrid>
                        <ContactIntroduction variants={fadeInUp}>
                            <div className='first'>
                                <h3>Patrick Assunção</h3>
                                <span className='dev'>Developer</span>
                                <ul>
                                    <li><span> Localidade:</span> Manaus - Am</li>
                                    <li><span>  Email:</span> patrickassuncaodev@gmail.com</li>
                                    <li>
                                        <div>
                                            <a href="https://github.com/patrickassuncao1" target="_blank" rel="noreferrer">
                                                <FaGithub size={26} />
                                            </a>
                                            <a href="https://www.linkedin.com/in/patrick-assunção" target="_blank" rel="noreferrer">
                                                <FaLinkedin size={26} />
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </ContactIntroduction>
                        <Form variants={fadeInUp} onSubmit={handleOnSubmit}>
                            <div>
                                <Input
                                    type="text"
                                    placeholder='Nome *'
                                    name='name'
                                    value={inputs.name}
                                    onChange={({ target: { value } }) => setInputs({ ...inputs, name: value })}
                                    required
                                />
                                <Input
                                    type="email"
                                    placeholder='email *'
                                    name='email'
                                    value={inputs.email}
                                    onChange={({ target: { value } }) => setInputs({ ...inputs, email: value })}
                                    required
                                />
                            </div>
                            <TextArea
                                placeholder='Digite sua Mensagem *'
                                name='description'
                                onChange={({ target: { value } }) => setInputs({ ...inputs, description: value })}
                                value={inputs.description}
                                required
                            >

                            </TextArea>

                            <div className='container-button'>
                                <Button text='Enviar Formulário' type='submit' />
                            </div>
                        </Form>
                    </FlexContainerGrid>
                </DivStyleWidth>

            </div>
            <RenderIf isTrue={loading}>
                <Loading />
            </RenderIf>

            <Alert
                visibility={alert.visibility}
                iconCheck={alert.iconCheck}
                opacity={alert.opacity}
                message={alert.message}
                setStyle={setAlert}
            />
        </Section>
    );
}

export default Contact;